<template>
  <tag-link
    :is="tag"
    v-bind="link"
    class="flex items-center text-gray-medium hover:text-blue-primary transition-colors"
  >
    <AppIcon
      name="view-dashboard-outline"
      viewBox="0 0 12 12"
      size="tiny"
    />
    <span class="text__sub--1 mr-2">
      {{ text }}
    </span>
  </tag-link>
</template>

<script>

export default {
  name: 'CtaTeacher',
  inject: ['allProps'],
  computed: {
    auth () {
      return this.allProps.data.auth
    },
    commonLink () {
      return {
        startTeaching: this.allProps.data.linksHeaderTop.startTeaching,
        dashboardTeacher: this.allProps.data.linksHeaderTop.dashboardTeacher
      }
    },
    tag () {
      return 'a'
    },
    text () {
      return this.auth.user.teacher.status === 'approved' ? this.$t('menu.dashboard_teacher') : this.$t('menu.register_teacher')
    },
    classBtn () {
      return this.auth.user.teacher.status === 'approved' ? '' : 'startTeachingClick'
    },
    link () {
      return this.auth.user.teacher.status === 'approved' ? this.commonLink.dashboardTeacher.attrTag : this.commonLink.startTeaching.attrTag
    }
  }
}
</script>
